import { Container, Grid } from "@mui/material";
import { ReportsSimpleReportHeader } from "../components";
import { spacing } from "~/pages/reports/utils/reportsConstants";
import { Stats } from "~/components/DetailsPage/components";
import { ReportType } from "~/reportApp/reportingApp";
import { useChecksOrVulnerabilitiesReport } from "./hooks/useChecksOrVulnerabilities";
import { ChecksReportsTable } from "./components/ChecksReportsTable";
import { VulnerabilitiesReportsTable } from "./components/VulnerabilitiesReportsTable";
import { CheckReportPrintMttrSlaCard } from "./components/CheckReportPrintMttrSlaCard";
import { ReportsSectionHeading } from "~/pages/reports/components/ReportsSectionHeading";
import { ReportsGroupSummary } from "~/pages/reports/components/ReportsGroupSummary";

interface ChecksOrVulnerabilitiesReportProps {
  reportType: ReportType;
}

export function ChecksOrVulnerabilitiesReport({
  reportType,
}: ChecksOrVulnerabilitiesReportProps) {
  const {
    scopeMrn,
    title,
    stats,
    groupSummary,
    // riskFactorsWithDocs,
    // totalScanned,
    // inventoryBreakdown,
  } = useChecksOrVulnerabilitiesReport({ reportType });

  return (
    <Container sx={{ p: 4 }}>
      <Grid container sx={{ mb: spacing[25] }}>
        <ReportsSimpleReportHeader title={title} />
        <Stats id="detail-content-stats" stats={stats} />
        <ReportsGroupSummary groupSummary={groupSummary} />
      </Grid>
      {reportType === ReportType.Vulnerabilities && (
        <Grid size={12} sx={{ mb: spacing[50] }}>
          <ReportsSectionHeading heading="MTTRs and SLAs" />
          <CheckReportPrintMttrSlaCard scopeMrn={scopeMrn} />
        </Grid>
      )}
      {/* <Grid size={12} sx={{ mb: spacing[25] }}> */}
      {/* <RiskFactors dataType="security" riskFactors={riskFactorsWithDocs} /> */}
      {/* </Grid> */}
      {/* <Grid size={12} sx={{ mb: spacing[50] }}>
        <SectionHeading
          heading="Inventory breakdown"
          dividerContent={
            totalScanned ? `${totalScanned} Assets total` : undefined
          }
        />
        <SecurityReportInventoryList softwareEdges={inventoryBreakdown} />
      </Grid> */}
      {reportType === ReportType.Checks && <ChecksReportsTable />}
      {reportType === ReportType.Vulnerabilities && (
        <VulnerabilitiesReportsTable />
      )}
    </Container>
  );
}
